<script>
  import Cell from "./Cell.svelte";
</script>

<div class="row">
  <Cell label={""} isToShow={false} percentage={0} />
  <Cell label={"1º"} percentage={1} />
  <Cell label={"2º"} percentage={1} />
  <Cell label={"3º"} percentage={1} />
  <Cell label={"4º"} percentage={1} />
</div>
